
import { defineComponent } from 'vue'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'
import { displayLanguage, normalizeLanguage } from './display'
export default defineComponent({
  setup() {
    const store = useStore(), i18n = useI18n()
    const change = (event: Event) => {
      const value = normalizeLanguage((event.target as HTMLSelectElement).value)
      store.commit('app/changeLanguage', value)
      i18n.locale.value = value
    }
    return { language: displayLanguage, change }
  }
})
